import { Component, ViewChild, OnInit, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, Validators, AbstractControl } from '@angular/forms';
import { typeDHLFormControls } from '../../models/dhl-form-shared-types';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DhlFormControl } from '../../models/dhl-form-control';

@Component({
    selector: 'app-app-form-field-datepicker',
    templateUrl: './form-field-datepicker.component.html',
    styleUrls: ['./form-field-datepicker.component.scss']
    // pipes: [ CheckErrorPipe ]
    ,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldDatePickerComponent implements OnInit {

  @Input() configData: DhlFormControl;
  @Input() frmGroup: UntypedFormGroup;

  @Output() dateChange:EventEmitter < MatDatepickerInputEvent< any>>;
  @Input() min;
  @Input() max;

  @ViewChild('picker', {static: true}) datePicker: MatDatepicker<Date>;
  
  //date = new FormControl(new Date());  
  //this.maxDate.setDate(this.minDate.getDate() + 1);
  //maxDate = new Date().setDate(this.minDate+ 5)

  minDate = new Date();
  maxDate;
  constructor() {        
   }

  error:any={isError:false,errorMessage:''};

  compareTwoDates(e){
    
    // generic date validation
    let name = this.configData.name;       
    let fieldValue = this.frmGroup.get(name).value;

    if(+ new Date(fieldValue) > 0 && fieldValue){
      this.configData.validation.forEach(check=>{
        let validationCheck = check.split('-');            
        if(validationCheck[0] === 'after' ){
          let nextFieldValue;
          let nextField;
          if(validationCheck[2] && this.frmGroup.parent['componentType'] == 'WRAPPER')
            nextField = this.frmGroup.parent.parent.get(validationCheck[2])['controls'][0].get(validationCheck[1]).value;
          else
            nextField = this.frmGroup.get(validationCheck[1]).value;  

          nextFieldValue = nextField;    
          if(!(this.configData.type === 'insertDate') && event.type === 'click'){    
            nextField['maxDate'] = fieldValue;
          }          
          if(+ new Date(fieldValue) < + new Date(nextFieldValue) && fieldValue && nextFieldValue){        
            this.frmGroup.get(name).markAsTouched();        
            this.frmGroup.get(name).setErrors({[name]: true});   // change in html        
          }
        }
        if(validationCheck[0] === 'before' ) {        
          let nextFieldValue;
          let nextField;
          if(validationCheck[2] && this.frmGroup.parent['componentType'] == 'WRAPPER')
            nextField = this.frmGroup.parent.parent.get(validationCheck[2])['controls'][0].get(validationCheck[1]);
          else
            nextField = this.frmGroup.get(validationCheck[1]);
          
          nextFieldValue = nextField;  
          if(!(this.configData.type === 'insertDate') && event.type === 'click'){            
            nextField['minDate'] = fieldValue;
            // !(this.configData.type === 'insertDate') &&
            if(nextFieldValue && fieldValue && (+ new Date(fieldValue) > + new Date(nextFieldValue))){
              nextField.setValue(fieldValue);
              nextFieldValue = fieldValue;
            }            
          }            
          if(+ new Date(fieldValue) > + new Date(nextFieldValue) && fieldValue && nextFieldValue){        
            this.frmGroup.get(name).markAsTouched();        
            this.frmGroup.get(name).setErrors({[name]: true});   // change in html        
          }
        }                
      })  
    }        
  }
   
  getControlMinDate(){
    return this.frmGroup.get(this.configData.name)['minDate'];
  }
  getControlMaxDate(){
    return this.frmGroup.get(this.configData.name)['maxDate'];
  }

  ngOnInit() {
    
    let name = this.configData.name;      
    this.configData.validation.forEach(check=>{
      let validationCheck = check.split('-');
      if(validationCheck[0] === 'before' )
        this.frmGroup.controls[name]['minDate'] = new Date(new Date().toDateString());            
      if(validationCheck[0] === 'after' ){
        let nextFieldValue;
        if(validationCheck[2] && this.frmGroup.parent['componentType'] == 'WRAPPER')
          nextFieldValue = this.frmGroup.parent.parent.get(validationCheck[2])['controls'][0].get(validationCheck[1]).value
        else
          nextFieldValue = this.frmGroup.get(validationCheck[1]).value;

        this.frmGroup.controls[name]['minDate'] = new Date(nextFieldValue);      
      }        
      if(validationCheck[0] === 'removeMinDate')
        this.frmGroup.controls[name]['minDate'] = null;
    })

    if(this.frmGroup.controls[name].value !== '' && this.frmGroup.controls[name].value !== null ){    
      this.frmGroup.controls[name].setValue(new Date(this.frmGroup.controls[name].value));           
    }    
    this.frmGroup.controls[name].setValidators([this.checkValidDates]);
  }  

  checkValidDates(control: AbstractControl){    
    let value = + new Date(control.value);
    let minValue = + new Date(control['minDate']);
    if(value > 0 && value < minValue){
      control.markAsTouched();            
      return {'matDatepickerMin': true};
    }
    else{
      return null;
    }
  }
}